import React, { useRef, useState } from "react";
import Card from "../../../elements/Card";
import Input from "../../../form/Input";
import Select from "../../../form/select/Select";
import useClickOutside from "../../../../hooks/useClickOutside";
import { t } from "i18next";

const ReadOnly = ({ data, onEditMode = () => {} }) => {
  return (
    <Card
      title={
        <div className="flex items-center justify-between">
          {t("Address")}{" "}
          <button
            type="button"
            onClick={() => {
              onEditMode();
            }}
          >
            <i className="fa-fw fa-regular fa-pen"></i>
          </button>
        </div>
      }
      bodyClass={"space-y-6"}
      className={" py-4 md:py-8 px-3 md:px-6"}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-1">
          <div class="font-medium font-CanelaDeck !text-base !text-gray-800">
            {t("Address")}
          </div>
          <div class="text-text-disabled font-medium">
            {data?.address1 || "N/A"}
          </div>
        </div>
        <div class="space-y-1">
          <div class="font-medium font-CanelaDeck !text-base !text-gray-800">
            {t("Address 2")}
          </div>
          <div class="text-text-disabled font-medium">
            {data?.address2 || "N/A"}
          </div>
        </div>
        <div class="space-y-1">
          <div class="font-medium font-CanelaDeck !text-base !text-gray-800">
            {t("City")}
          </div>
          <div class="text-text-disabled font-medium">
            {data?.city || "N/A"}
          </div>
        </div>
        <div class="space-y-1">
          <div class="font-medium font-CanelaDeck !text-base !text-gray-800">
            {t("Zipcode")}
          </div>
          <div class="text-text-disabled font-medium">
            {data?.zipcode || "N/A"}
          </div>
        </div>
        <div class="space-y-1">
          <div class="font-medium font-CanelaDeck !text-base !text-gray-800">
            {t("State")}
          </div>
          <div class="text-text-disabled font-medium">
            {data?.state || "N/A"}
          </div>
        </div>
        <div class="space-y-1">
          <div class="font-medium font-CanelaDeck !text-base !text-gray-800">
            {t("Country")}
          </div>
          <div class="text-text-disabled font-medium">
            {data?.country || "N/A"}
          </div>
        </div>
      </div>
    </Card>
  );
};

const AddressDetails = ({
  values,
  handleChange = () => {},
  loadDataOnScroll = () => {},
  profileDetailsData = {},
  countryData,
  setCountryKeyword = () => {},
  setCountryFilter = () => {},
  countryKeyword,
}) => {
  const divRef = useRef(null);
  const [readOnly, setReadOnly] = useState(true);

  useClickOutside(divRef, () => {
    setReadOnly(true);
  });

  return (
    <div ref={divRef}>
      {readOnly ? (
        <ReadOnly data={values} onEditMode={() => setReadOnly(false)} />
      ) : (
        <Card
          title={t("Address")}
          bodyClass={"space-y-6"}
          className={"py-6 px-3 md:px-6"}
        >
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12">
              <div className="relative">
                <Input
                  label={t("Address")}
                  labelClasses={"!text-lg !text-deep-purple !mb-2"}
                  inputClasses={
                    "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                  }
                  inputName={"address1"}
                  value={values?.address1 || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-span-12">
              <div className="relative">
                <Input
                  label={t("Address 2")}
                  labelClasses={"!text-lg !text-deep-purple !mb-2"}
                  inputClasses={
                    "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                  }
                  inputName={"address2"}
                  value={values?.address2 || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-span-12 xl:col-span-6">
              <div className="relative">
                <Input
                  label={t("City")}
                  labelClasses={"!text-lg !text-deep-purple !mb-2"}
                  inputClasses={
                    "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                  }
                  inputName={"city"}
                  value={values?.city || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-span-12 xl:col-span-6">
              <div className="relative">
                <Input
                  label={t("Zipcode")}
                  inputName={"zipcode"}
                  value={values?.zipcode || ""}
                  labelClasses={"!text-lg !text-deep-purple !mb-2"}
                  inputClasses={
                    "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                  }
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-span-12 xl:col-span-6">
              <div className="relative">
                <Input
                  label={t("State")}
                  inputName={"state"}
                  value={values?.state || ""}
                  labelClasses={"!text-lg !text-deep-purple !mb-2"}
                  inputClasses={
                    "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                  }
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-span-12 xl:col-span-6">
              <Select
                dropdownData={[
                  ...(profileDetailsData?.address?.country
                    ? [
                        {
                          name: profileDetailsData?.address?.country,
                          value: profileDetailsData?.address?.country,
                        },
                      ]
                    : []),
                  ...(countryData?.data || [])
                    .filter(
                      (item) =>
                        !profileDetailsData?.address?.country ||
                        item?.name !== profileDetailsData?.address?.country
                    )
                    .map((item) => ({
                      name: item?.name,
                      value: item?.name,
                    })),
                ]}
                selectedValue={values?.country || ""}
                onChange={(val, fullItem) => {
                  handleChange({
                    target: { name: "country", value: val },
                  });
                }}
                isSearch
                onSearchHandler={(val) => {
                  setCountryKeyword(val);
                  setCountryFilter((pre) => ({ ...pre, page: 1 }));
                }}
                search={countryKeyword}
                placeholder="--"
                label={t("Select a country")}
                labelClasses={"text-lg text-deep-purple mb-2"}
                dropdownClass={"w-full"}
                dropdownButtonClass={"rounded-md"}
                onScroll={(e) => {
                  loadDataOnScroll({
                    event: e,
                    metadata: countryData?.metadata,
                    setData: setCountryFilter,
                  });
                }}
              />
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default AddressDetails;
